import { render, staticRenderFns } from "./votePublicDetail.vue?vue&type=template&id=50e3a728&scoped=true&"
import script from "./votePublicDetail.vue?vue&type=script&lang=js&"
export * from "./votePublicDetail.vue?vue&type=script&lang=js&"
import style0 from "./votePublicDetail.vue?vue&type=style&index=0&id=50e3a728&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e3a728",
  null
  
)

export default component.exports